<template>
    <v-dialog width="400" v-model="isOpenReportDateFilter">
        <v-card>
            <v-card-title primary-title>
                <div
                    v-if="$vuetify.breakpoint.xs"
                    class="primary--text text-overline ml-2"
                >
                    <v-icon left> mdi-calendar </v-icon>
                    Mes a consultar
                </div>
                <div
                    v-else
                    class="font-weight-light primary--text text-h4 ml-2"
                >
                    <v-icon large left> mdi-calendar </v-icon>
                    Mes a consultar
                </div>
            </v-card-title>
            <!-- <v-divider class="test"></v-divider> -->
            <v-row class="d-flex justify-center mt-4 mx-1">
                <v-col cols="12">
                    <v-row justify="space-around">
                        <v-date-picker
                            v-model="picker"
                            :max="
                                new Date(
                                    Date.now() -
                                        new Date().getTimezoneOffset() * 60000
                                )
                                    .toISOString()
                                    .substr(0, 10)
                            "
                            type="month"
                            color="grey darken-3"
                        ></v-date-picker>
                    </v-row>
                </v-col>
            </v-row>
            <v-card-actions class="justify-end">
                <v-btn
                    depressed
                    color="success"
                    @click="
                        submit();
                        isOpenReportDateFilter = false;
                    "
                >
                    Buscar
                </v-btn>
                <v-btn text color="red" @click="isOpenReportDateFilter = false">
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>


<script>
export default {
    name: 'DateFilterDialog',
    data: () => ({
        picker: new Date().toISOString().substr(0, 7),
    }),
    methods: {
        submit() {
            this.$emit('dateEvent', this.picker);
            // this.$store.state.objectivesReport.date = this.picker;
            // // this.$store.dispatch('objectivesReport/fetchHolidayEventsinMonth')
            // this.$store.dispatch('objectivesReport/fetchConsecucion');
        },
    },
    computed: {
        isOpenReportDateFilter: {
            get() {
                return this.$store.state.reportTable.isOpenReportDateFilter;
            },
            set(value) {
                this.$store.commit('reportTable/isOpenReportDateFilter', value);
            },
        },
    },
};
</script>